import React from "react";
import get from "lodash/get";
import clone from "lodash/clone";
import uniq from "lodash/uniq";
import Select from "react-select";

import connectToStores from "alt-utils/lib/connectToStores";
import PassBucketActions from "../../../actions/PassBucketActions";
import PassBucketStore from "../../../stores/PassBucketStore";
import TagActions from "../../../actions/TagActions";
import TagStore from "../../../stores/TagStore";

class ConfiguratorInjectedSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      objects: []
    };
  }

  static getStores() {
    return [PassBucketStore, TagStore];
  }

  static getPropsFromStores() {
    return {
      getPassBucketsForEventBucket:
        PassBucketStore.getPassBucketsForEventBucket,
      getTagsForEventBucket: TagStore.getTagsForEventBucket,
      getMembershipsForEventBucket:
        PassBucketStore.getMembershipsForEventBucket,
    };
  }

  componentDidMount() {
    let { inject, eventBucket } = this.props;
    if (inject.objects === "pass_buckets" || inject.objects === "memberships") {
      PassBucketActions.fetchAllForEventBucket.defer(eventBucket.id);
    } else if (inject.objects === "tags") {
      TagActions.fetchAllForBucket.defer(eventBucket.id);
    }
  }

  componentWillReceiveProps(newProps) {
    let { inject, value, eventBucket } = newProps;

    if (inject.objects === "pass_buckets") {
      this.setState({
        objects: newProps.getPassBucketsForEventBucket(eventBucket.id)
      });
    } else if (inject.objects === "tags") {
      this.setState({
        objects: newProps.getTagsForEventBucket(eventBucket.id)
      });
    } else if (inject.objects === "memberships") {
      this.setState({
        objects: newProps.getMembershipsForEventBucket(eventBucket.id)
      })
    }
  }

  render() {
    let { type, inject, repeatable, repeatableKey, value, onChange } =
        this.props,
      { objects } = this.state;

    // Default value to empty array
    if (repeatable && !value) {
      value = [];
    }

    if (type === "multiselect") {
      let options = objects.map(o => {
        return {
          label: get(o, inject.label),
          value: get(o, inject.value)
        };
      });

      // For each selected value, clone it again
      if (repeatable && value.length) {
        options = options.concat(
          [].concat.apply(
            [],
            uniq(value.filter(x => !!x).map(v => v.replace(/--.*$/, "")))
              .map(v => {
                let total = value.filter(val => val.startsWith(v)).length,
                  baseObject = options.find(o => o.value === v);

                if (!baseObject) {
                  return undefined;
                }

                return new Array(total).fill().map((_, i) => {
                  let o = clone(baseObject);
                  o.value += `--${repeatableKey}${i + 1}`;
                  return o;
                });
              })
              .filter(o => !!o)
          )
        );
      }

      return (
        <Select
          autosize={false}
          multi={true}
          placeholder="None selected"
          value={value}
          options={options}
          onChange={selected => {
            onChange(selected ? selected.map(s => s.value) : []);
          }}
        />
      );
    }
  }
}

export default connectToStores(ConfiguratorInjectedSelect);



// WEBPACK FOOTER //
// ./src/app/components/partials/configurator/configurator-injected-select.jsx